<script setup lang="ts">
import { toRef } from "vue";
defineOptions({
    inheritAttrs: false,
});
const props = defineProps({
    type: {
        type: String,
        default: "text",
        required: false,
    },
    value: {
        type: [String, null],
        default: "",
    },
    modelValue: {
        type: [String, null],
        default: "",
    },
    name: {
        type: String,
        required: true,
    },
    error: {
        type: String,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    selectText: {
        type: String,
        required: false,
    },
    maxLength: {
        type: Number,
        default: null,
    },
    items: {
        type: Array,
    },
    ariaLabel: {
        type: String,
        default: null,
    },
});

const emit = defineEmits(["update:modelValue"]);

const name = toRef(props, "name");
</script>

<template>
    <select
        :name="name"
        :id="name"
        class="form-select"
        :class="{'is-invalid': !!error}"
        @input="emit('update:modelValue', $event.target.value)"
        :disabled="disabled"
        :value="modelValue"
        :aria-describedby="error ? `${name}-error` : null"
        :aria-label="ariaLabel || undefined"
    >
        <option
            value=""
            v-if="selectText"
        >
            {{ selectText }}
        </option>
        <option
            v-for="item in items"
            :value="item.value"
            :key="item.value"
        >
            {{ item.text }}
        </option>
    </select>
    <span
        :id="`${name}-error`"
        class="invalid-feedback"
        role="alert"
        v-if="error"
    >
        {{ error }}
    </span>
</template>
